export default __webpack_public_path__ + "static/media/moles-removal.a22cf201.pdf";